import { render, staticRenderFns } from "./LaundryDeliveryActions.vue?vue&type=template&id=7ab64541&scoped=true"
import script from "./LaundryDeliveryActions.vue?vue&type=script&lang=js"
export * from "./LaundryDeliveryActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab64541",
  null
  
)

export default component.exports